/**
 * Kleiner Speicher je Verlaufseintrag im sessionStorage: Scrollposition und
 * Ansichts-Gedächtnis (aufgeklappte Gruppen, Nachlade-Stand). Reine Funktionen über einem
 * austauschbaren Speicher, damit sie ohne Browser testbar sind.
 *
 * Gekappt auf die jüngsten Einträge, damit der Speicher nicht vollläuft.
 */
export interface KeyValueStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

const MAX_ENTRIES = 150;

type Bucket = Array<[string, unknown]>;

function readBucket(store: KeyValueStore, bucket: string): Bucket {
  try {
    const raw = store.getItem(bucket);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed.filter((e) => Array.isArray(e) && typeof e[0] === 'string') as Bucket) : [];
  } catch {
    // Speicher gesperrt oder Inhalt beschädigt → wie leer behandeln.
    return [];
  }
}

export function readEntry<T>(store: KeyValueStore, bucket: string, key: string): T | undefined {
  const hit = readBucket(store, bucket).find((e) => e[0] === key);
  return hit ? (hit[1] as T) : undefined;
}

export function writeEntry(store: KeyValueStore, bucket: string, key: string, value: unknown): void {
  const rest = readBucket(store, bucket).filter((e) => e[0] !== key);
  rest.push([key, value]);
  try { store.setItem(bucket, JSON.stringify(rest.slice(-MAX_ENTRIES))); } catch { /* Speicher voll oder gesperrt: Ansicht startet beim nächsten Mal im Standard */ }
}

export function sessionStore(): KeyValueStore | null {
  try { return typeof window === 'undefined' ? null : window.sessionStorage; } catch { return null; }
}
